export const SEND_SCM_INFO = 'SEND_SCM_INFO';
export type SEND_SCM_INFO = typeof SEND_SCM_INFO;

export const SEND_SCM_INFO_ERROR = 'SEND_SCM_INFO_ERROR';
export type SEND_SCM_INFO_ERROR = typeof SEND_SCM_INFO_ERROR;

export const SEND_SCM_INFO_LOADING = 'SEND_SCM_INFO_LOADING';
export type SEND_SCM_INFO_LOADING = typeof SEND_SCM_INFO_LOADING;